import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyDLLPGGY9hpZpKUxYkjaoY0Y5-C1ZirGRo',
  authDomain: 'waymining-za.firebaseapp.com',
  projectId: 'waymining-za',
  storageBucket: 'waymining-za.firebasestorage.app',
  messagingSenderId: '881029462004',
  appId: '1:881029462004:web:95f9d8c1a2415fad6ceba1',
  measurementId: 'G-22XRF98HF1',
};

export const app = initializeApp(firebaseConfig);

isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});
